import { render, staticRenderFns } from "./judgeDialog.vue?vue&type=template&id=75aab38a"
import script from "./judgeDialog.vue?vue&type=script&lang=js"
export * from "./judgeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports